/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '../../actions.constants';
import { storeMutations } from '../../mutations.constants';

const userActions = {
  [storeActions.createLicense]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/licenses/addLicense', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getCustomerList]: ({ commit }, payLoad) => {
    let search
    if(payLoad.search){
      search = {search:payLoad.search}
      }
      else{
        search = {}
      }
    return httpClient.post(`customer/list?page=${payLoad.page}&limit=${payLoad.limit}`,search,).then(
      (res) => {
        console.log("value are",res);

        commit(storeMutations.setCustomerInfo, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setCustomerInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getCustomerProfileById]: ({ commit }, payLoad) => {
    console.log("payload is",payLoad);
    return httpClient.get(`customer/customerById/${payLoad.id}`).then(
      (res) => {
        console.log("value is",res);

        commit(storeMutations.setCustomerProfileByIdInfo, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setCustomerProfileByIdInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getTierDetails]: ({ commit }, payLoad) => {
    return httpClient.get('/tier/getTierDetails', payLoad).then(
      (res) => {
        commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getTierList]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.get('/tier/getTierList', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getLicenseByid]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.get('/licenses/getLicenseById/' + payLoad.licenseId).then(
      (res) => {
        console.log(res);

        commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getTierById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.get('/tier/getTierById/' + payLoad.tier_id).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.updateLicenseByid]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/licenses/updateLicense', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getLicense]: ({ commit }, payLoad) => {
    let url=`/licenses/getLicenseList?page=${payLoad.page}&limit=${payLoad.limit}`
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search)url+=`&search=${payLoad.search}`
    if(payLoad.tiertype && payLoad.onboardType==='') url+=`&filter={"tier_name":"${payLoad.tiertype}"}`
    if(payLoad.onboardType && payLoad.tiertype==='')url+=`&filter={"onBoardType":"${payLoad.onboardType}"}`
    if(payLoad.onboardType && payLoad.tiertype)url+=`&filter={"onBoardType":"${payLoad.onboardType}","tier_name":"${payLoad.tiertype}"}`
    return httpClient
      .get(
        url,                                                                    
        payLoad,
      ).then(
        (res) => {
          commit(storeMutations.setLicenseMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setLicenseMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getLicensesCount]: ({ commit }, payLoad) => {
    return httpClient.get('/licenses/getLicenseCount', payLoad).then(
      (res) => {
        commit(storeMutations.setLicenseCount, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.setLicenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getMetricsCount]: ({ commit }, payLoad) => {
    return httpClient.get(`/customer/getMetrics/${payLoad.id}`, payLoad).then(
      (res) => {
        // commit(storeMutations.setCustomerMetricsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerMetricsByIdInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getProgramsCount]: ({ commit }, payLoad) => {
    return httpClient.get(`/customer/getPrograms/${payLoad.id}`, payLoad).then(
      (res) => {
        // commit(storeMutations.setCustomerProgramsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerProgramsByIdInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getVsmsCount]: ({ commit }, payLoad) => {
    return httpClient.get(`/customer/getVsms/${payLoad.id}`, payLoad).then(
      (res) => {
        // commit(storeMutations.setCustomerVsmsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerVsmsByIdInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getClientsCount]: ({ commit }, payLoad) => {
    return httpClient.get(`/customer/getClients/${payLoad.id}`, payLoad).then(
      (res) => {
        // commit(storeMutations.setCustomerClientsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerClientsByIdInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getConnectorsCount]: ({ commit }, payLoad) => {
    return httpClient.get(`/customer/getConnectors/${payLoad.id}`, payLoad).then(
      (res) => {
        // commit(storeMutations.setCustomerConnectorsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerConnectorsByIdInfo, err);
        return err.response;
      },
    );
  },
  [storeActions.getProjectsCount]: ({ commit }, payLoad) => {
    return httpClient.get(`/customer/getProjects/${payLoad.id}`, payLoad).then(
      (res) => {
        // commit(storeMutations.setCustomerProjectsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerProjectsByIdInfo, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };
